import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("token") || params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch (e) { console.debug("payment status poll retry", e?.message); }
      if (attempts >= 8) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="bg-white text-brand-ink min-h-screen">
      <PublicNav />
      <section className="pt-40 pb-32 px-6 text-center max-w-xl mx-auto" data-testid="payment-success-page">
        {status === "checking" && (<><Loader2 className="w-14 h-14 text-brand-red mx-auto animate-spin" /><h1 className="font-display text-4xl mt-6">Confirming your payment…</h1></>)}
        {status === "paid" && (<><CheckCircle2 className="w-16 h-16 text-green-600 mx-auto" /><h1 className="font-display text-5xl mt-6">Payment confirmed!</h1><p className="mt-4 font-serif text-xl text-brand-ink/70">Thank you — {info?.kind === "invoice" ? "your invoice is settled" : info?.kind === "bundle" ? "your session pack is ready to use" : "your session is booked"}. A receipt is on its way.</p></>)}
        {(status === "timeout" || status === "error") && (<><XCircle className="w-16 h-16 text-brand-red mx-auto" /><h1 className="font-display text-4xl mt-6">We couldn't confirm yet</h1><p className="mt-4 font-serif text-xl text-brand-ink/70">If you completed checkout, it may take a moment. Contact us if this persists.</p></>)}
        <Link to="/" className="mt-10 inline-block px-8 py-4 rounded-full bg-brand-red text-white font-medium hover:bg-brand-reddark transition-colors" data-testid="payment-home-btn">Back to home</Link>
      </section>
      <Footer />
    </div>
  );
}
